export default "__VITE_ASSET__19227fa5__"